import { IBurnSparklineProps } from 'types/fuelConsumption.interface'
import { SparkSvg } from './BurnSparkline.styled'

export const BurnSparkline = ({ values, color }: IBurnSparklineProps) => {
  if (!values.length) return null
  const width = 72
  const height = 20
  const pad = 2
  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min || 1
  const step = values.length > 1 ? (width - pad * 2) / (values.length - 1) : 0
  const points = values
    .map((value, i) => {
      const x = (pad + i * step).toFixed(1)
      const y = (height - pad - ((value - min) / span) * (height - pad * 2)).toFixed(1)
      return `${x},${y}`
    })
    .join(' ')
  return (
    <SparkSvg viewBox={`0 0 ${width} ${height}`} width={width} height={height}>
      <polyline
        points={points}
        fill='none'
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SparkSvg>
  )
}
